// extracted by mini-css-extract-plugin
module.exports = {"threeDotsPopover":"zx+rC","popoverLoadingItem":"-Xgi3","threeDotsButton":"orU9w","popoverButton":"LMFIg","popoverError":"mfOTX","skillTagRowIcon":"RSVqX"};